module.exports = __webpack_public_path__ + "static/media/img1-2.7a52bd40.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/aguacate/biosense/diff/img1-2.png
// module id = 1064
// module chunks = 3